import { connect } from 'react-redux';
import PdfViewer from './PdfViewer';
import { modalErrorOpen } from '../../store/actions/modalError';

const mapStateToProps = () => ({});
const mapDispatchToProps = { modalErrorOpen };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PdfViewer);
